export const BACKOFFICE_VIVAZ_DEFAULT_ROUTE = "/funil-de-propostas";

const BACKOFFICE_VIVAZ_ALLOWED_PATHS = [
  /^\/funil-de-propostas\/?$/,
  /^\/lead-detail\/[^/]+\/proposition-detail\/[^/]+\/?$/,
  /^\/lead-detail\/[^/]+\/[^/]+\/proposition-detail\/[^/]+\/[^/]+\/?$/,
  /^\/block\/?$/,
];

export const isBackofficeVivazAllowedPath = (path: string): boolean => {
  const cleanPath = path.split("?")[0].split("#")[0];

  return BACKOFFICE_VIVAZ_ALLOWED_PATHS.some((pattern) =>
    pattern.test(cleanPath)
  );
};
